// Enquiry List and Estimation are boards under the hood (with their own
// QPTS-PRJ-style boardId), but they're reached through dedicated routes
// (/workflow/enquiries, /workflow/estimation) so the sidebar highlights them
// instead of "Projects" — going through the generic /workflow/boards/:id
// path instead (as a plain navigate()/<Link> would) lights up the wrong nav
// item even though the board itself loads correctly.
// Request 1151: Estimation is split into two menus by stage — pass the task's stage to land on the menu that shows it.
const ESTIMATION_FOLLOW_UP_STAGES = ["Submitted/Follow-up", "Hold", "Lost"];
export function boardPath(boardName: string | undefined | null, boardId: string, stageName?: string | null): string {
  if (boardName === "Enquiry List") return "/workflow/enquiries";
  if (boardName === "Estimation") return stageName && ESTIMATION_FOLLOW_UP_STAGES.includes(stageName) ? "/workflow/estimation/follow-up" : "/workflow/estimation/active";
  return `/workflow/boards/${boardId}`;
}
